import { vec2 } from "@tlaukkan/tsm";
import { lerp, smoothStepInterp } from "./interpolation";

const a = 1664525;
const m = Math.pow(2, 32) - 1;
const c = 1013904223;

export class Rng {
	last: number;

	constructor(public seed: number) {
		this.last = seed * m;
	}

	next() {
		this.last = ((a * this.last + c) % m);
		return this.last / m;
	}

	unitVector() {
		return new vec2([(this.next() * 2) - 1, (this.next() * 2) - 1]).normalize();
	}

	unitScaler() {
		return (this.next() - 0.5) * 2;
	}

	positionInRadius(center: vec2, minDistance: number, maxDistance: number) {
		const rand = this.next();
		const distance = minDistance + (rand * (maxDistance - minDistance));
		return this.unitVector()
			.scale(distance)
			.add(center)
	}
}


export class SmoothNoiseMachine {
	private rng: Rng;
	private lastRandom: number;
	private nextRandom: number
	private progress = 0;

	constructor(public seed: number) {
		this.rng = new Rng(seed);
		this.lastRandom = this.rng.next();
		this.nextRandom = this.rng.next();
	}

	/**Get the next noise number. size = 1 gives the next random number, fractions give smooth interpolation between */
	step(stepSize: number) {
		this.progress += stepSize;
		const integer = Math.floor(this.progress);
		this.progress -= integer;
		for (let i = 0; i < integer; ++i) {
			this.lastRandom = this.nextRandom;
			this.nextRandom = this.rng.next();
		}
		return lerp(this.lastRandom, this.nextRandom, smoothStepInterp(0, 1, this.progress));
	}

	unitScalerStep(stepSize: number) {
		return (this.step(stepSize) - 0.5) * 2;
	}
}